import React, { lazy, Suspense } from 'react';
import { Router, Switch, Redirect } from 'react-router-dom';

import NotFound404 from '_common/components/NotFound404';
import OKRoute from '_common/components/OKRoute';
import Page from '_common/constants/PageLink';
import OldPage from '_common/constants/PageURL';
import App from '_common/container/App';
import history from '_common/history';

const SocialAccountRegister = lazy(() => {
  return import('./pages/login/SocialAccountRegister');
});

const SocialLoginBindAccount = lazy(() => {
  return import('./pages/login/SocialAccountBind');
});

const LoginSecondVerify = lazy(() => {
  return import('./pages/login/LoginSecondVerify');
});

const LoginPWDForget = lazy(() => {
  return import(
    '_common/container/account/security/securityModify/LoginPWDForget'
  );
});
const Login = lazy(() => {
  return import('./pages/login/Login');
});
const Register = lazy(() => {
  return import('./pages/login/Register');
});
const RegisterSuccess = lazy(() => {
  return import('./pages/login/components/RegisterSuccess');
});
const Account = lazy(() => {
  return import('./pages/account/Account');
});
const Balance = lazy(() => {
  return import('./pages/balance/Balance');
});
const Referral = lazy(() => {
  return import('./pages/referral');
});
const Join = lazy(() => {
  return import('./pages/join/Join');
});
const Welcome = lazy(() => {
  return import('./pages/join/Welcome');
});

const Passkey = lazy(() => {
  return import('./pages/account/security/passkey');
});

const asyncRouteMap = [
  {
    // 通行密钥 - 独立页面（需要在前面，避免被 users 路由拦截）
    path: Page.passkey,
    component: Passkey,
    exact: false,
    intercept: true,
  },
  {
    // 用户中心
    path: Page.users,
    component: Account,
    exact: false,
    intercept: true,
  },
  {
    // 资金管理
    path: Page.balance,
    component: Balance,
    exact: false,
    intercept: true,
  },
];

const routeMap = [
  // Development only: localhost:3003 (/) redirect
  ...(process.env.NODE_ENV === 'development'
    ? [
        {
          path: '/',
          component: () => {
            return <Redirect to={Page.balance} />;
          },
          exact: true,
          intercept: false,
        },
      ]
    : []),
  {
    // 登录
    path: Page.login,
    component: Login,
    exact: true,
    intercept: true,
  },
  {
    // /account redirect
    path: Page.root,
    component: () => {
      return <Redirect to={Page.balance} />;
    },
    exact: true,
    intercept: false,
  },
  {
    path: Page.socialLoginBindAccount,
    component: SocialLoginBindAccount,
    exact: true,
    intercept: true,
  },
  {
    path: Page.socialAccountRegister,
    component: SocialAccountRegister,
    exact: true,
    intercept: true,
  },
  {
    path: Page.loginSecondVerify,
    component: LoginSecondVerify,
    exact: true,
    intercept: true,
  },
  {
    // 注册
    path: Page.register,
    component: Register,
    exact: true,
    intercept: true,
  },
  {
    path: Page.forgetLoginPassword,
    component: LoginPWDForget,
    exact: true,
    intercept: true,
  },
  {
    // 注册成功
    path: Page.registerSuccess,
    component: RegisterSuccess,
    exact: true,
    intercept: false,
  },
  {
    // Referral
    path: Page.referral,
    component: Referral,
    exact: true,
    intercept: false,
  },
  {
    // Join
    path: Page.join,
    component: Join,
    exact: true,
    intercept: false,
  },
  {
    // welcome
    path: Page.welcome,
    component: Welcome,
    exact: true,
    intercept: false,
  },
  {
    // 404 fallback
    path: '*',
    component: NotFound404,
    exact: false,
    intercept: false,
  },
];

// 需要重定向的路由
const redirectMap = [
  'forgetLoginPassword',
  'modifyLoginPassword',
  'modifyPhone',
  'setPhone',
  'modifyGoogle',
  'setGoogle',
  'modifyEmail',
  'setEmail',
  'forgetTradePassword',
  'modifyTradePassword',
  'setTradePassword',
  'etfAccountPage',
  'cardPage',
  'earningsDoubledDetailPage',
  'encourageGoldDetailPage',
  'miningDetailPage',
];

export default (
  <Router history={history}>
    <App>
      <Suspense fallback={<></>}>
        <Switch>
          {
            // 重定向变更的路由
            redirectMap.map((item, index) => {
              return (
                <Redirect
                  key={`redirect${index}`}
                  from={OldPage[item]}
                  to={Page[item]}
                />
              );
            })
          }
          {asyncRouteMap.map((item, index) => {
            return (
              <OKRoute
                key={index}
                path={item.path}
                exact={item.exact}
                intercept={item.intercept}
                component={(() => {
                  return item.component;
                })()}
              />
            );
          })}
          {routeMap.map((item, index) => {
            return (
              <OKRoute
                notAuth
                key={index}
                path={item.path}
                exact={item.exact}
                intercept={item.intercept}
                component={(() => {
                  return item.component;
                })()}
              />
            );
          })}
        </Switch>
      </Suspense>
    </App>
  </Router>
);
